export const BaseLineThumbdown = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.8 14.7V18.3C13.8 19.3817 13.1639 20.3148 12.2453 20.7457C11.6174 21.0403 10.985 20.5252 10.7858 19.8609C10.5129 18.9512 10.0718 17.6437 9.49988 16.4999C8.49988 14.4999 7.5 12.9 7.5 12.9V2.99998H17.958C18.8555 2.98983 19.6235 3.64254 19.758 4.52999L21 12.63C21.0792 13.1521 20.9252 13.6827 20.5787 14.0812C20.2322 14.4797 19.7281 14.706 19.2 14.7H13.8Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7.5 12.9997H5.097C4.04266 13.0184 3.14135 12.145 3 11.1001V4.80006C3.14135 3.75506 4.04266 2.98141 5.097 3.00006H7.5V12.9997Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
